import { NavLink, Outlet } from 'react-router-dom';
import { Home, UserPlus, User, Flame } from 'lucide-react';

export default function AppShell() {
  const tab = "flex flex-col items-center gap-0.5 py-2 px-4 text-xs transition-colors";
  const active = "text-burner-500";
  const idle = "text-gray-500";
  return (
    <div className="h-screen flex flex-col overflow-hidden">
      <nav className="sticky top-0 z-30 flex items-center h-13 px-4 backdrop-blur-xl bg-zinc-950/70 border-b border-white/[0.04]">
        <div className="flex items-center gap-2 text-burner-500 font-bold text-sm"><Flame size={18} />Burner Codes</div>
      </nav>
      <main className="flex-1 overflow-y-auto hide-scrollbar"><Outlet /></main>
      <nav className="sticky bottom-0 z-30 backdrop-blur-xl bg-zinc-950/90 border-t border-white/[0.06] safe-bottom">
        <div className="flex justify-around py-1">
          <NavLink to="/app" end className={({isActive})=>`${tab} ${isActive?active:idle}`}><Home size={20} /><span>Home</span></NavLink>
          <NavLink to="/app/invite" className={({isActive})=>`${tab} ${isActive?active:idle}`}><UserPlus size={20} /><span>Invite</span></NavLink>
          <NavLink to="/app/profile" className={({isActive})=>`${tab} ${isActive?active:idle}`}><User size={20} /><span>Profile</span></NavLink>
        </div>
      </nav>
    </div>
  );
}
